function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
import React from "react";
export var IconYoutube = function IconYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _object_spread({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100",
    height: "73",
    viewBox: "0 0 100 73",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6.90746 8.84199C10.9281 4.93494 18.7631 4.72931 25.6703 3.80396C45.3611 1.85044 68.0415 1.74762 85.7734 5.44903C93.2992 6.99128 96.392 13.1603 97.1136 20.2547C98.4538 31.6673 98.4539 45.1364 96.2889 56.4462C94.9487 63.4378 90.0002 67.1392 82.8868 68.0645C61.1343 71.2518 32.4745 72.1772 10.825 66.5223C3.5054 63.5406 3.40231 57.0631 2.78375 48.8378C2.37138 40.7152 2.47447 31.3589 2.98993 23.3392C3.5054 17.0673 3.5054 12.6462 6.90746 8.84199Z",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9991 36.1912L44.5352 45.0334V27.2461L59.9991 36.1912Z",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeMiterlimit: "10"
  }));
};